import { Card } from '@ox-technologies/ui';
import { ReactNode } from 'react';

/**
 * White surface card that hosts the public-page content (login, register,
 * password recovery, ...). On desktop it hugs its content (440px wide,
 * vertically centered, scrolls internally if a long form exceeds the panel);
 * full width with a tighter padding (scrollable) below the `md` breakpoint.
 */
const IdentityCard = ({ children }: { children: ReactNode }) => {
  return (
    <Card
      variant="large"
      padding="none"
      className="z-[756] max-h-full w-[440px] self-center overflow-y-auto p-[40px] max-md:h-full max-md:w-full max-md:self-auto max-md:overflow-y-scroll max-md:p-[24px]"
    >
      {children}
    </Card>
  );
};

export default IdentityCard;
